export default "__VITE_ASSET__CUwgHj6C__"